<template>
  <v-dialog v-model="dialog" max-width="560" scrollable>
    <v-card class="dialog-change-log-card">
      <v-card-title class="navy darken-1 white--text">
        Novità Asta Live
        <v-spacer />
        <v-btn depressed class="white--text" light icon @click="dismiss">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="change-log-content pa-4">
        <v-timeline dense clipped class="change-log-timeline">
          <v-timeline-item
            v-for="event in visibleEvents"
            :key="`${event.date}-${event.title}`"
            color="secondary"
            small
          >
            <div class="change-log-date">{{ event.date }}</div>
            <div class="change-log-title">{{ event.title }}</div>
            <div
              v-if="event.description"
              class="change-log-description"
              v-html="event.description"
            ></div>
          </v-timeline-item>
        </v-timeline>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import db from "../../js/db";
import Config from "../../../config-app/config";
import mixins from "../../js/mixins";

export default {
  name: "dialog-change-log",
  mixins: [mixins],
  data() {
    return {
      dialog: false,
      events: [
         {
          date: "27 Settembre 2026",
          title: "Pianificazione Rosa migliorata. E piú evidente su schermi 'mobile'",
        },
         {
          date: "26 Settembre 2026",
          title: "Possibilitá di modificare da quanti calciatori deve essere composta la rosa in ciascun ruolo",
          onlyOnStandalone: true,
          description:
            "Ora puoi scegliere tra 'Esattamente', 'Almeno...', 'Un massimo di...', 'A piacere / illimitati'",
        },
        {
          date: "23 Settembre 2026",
          title: "Scarta calciatori sotto una certa quotazione",
          description:
            "In 'Aggiungi scartati' puoi ora scartare tutti gli svincolati con quotazione inferiore o uguale alla soglia scelta, limitatamente ai ruoli selezionati.",
        },
        {
          date: "23 Settembre 2026",
          title: "Ruoli mantra visibili nella pianificazione obiettivi",
          onlyOnStandalone: true,
                  },
        {
          date: "23 Settembre 2026",
          title: 'Aggiunto "Cerca" nella lista "Scartati"',
          description:
            "Ora puoi cercare i calciatori scartati per nome o squadra di club.",
        },
        {
          date: "20 Settembre 2026",
          title: "Rilancio +5 in Asta Selvaggia",
          description:
            "Nuovo pulsante +5, accanto al +1, in Asta Selvaggia",
        },
        {
          date: "16 Settembre 2026",
          title: "Lista partecipanti",
          description:
            "Nella visuale Panoramica puoi mostrare la lista partecipanti, scegliere quali valori visualizzare e ordinarla per tavolo, crediti residui, offerta massima o nome squadra.",
        },
        {
          date: "23 Agosto 2026",
          title: "Testo che spiega uscita automatica dall'asta",
          description:
            "Quando il sistema ti fa uscire automaticamente dall'asta, ora viene mostrato il motivo (es: 'Ruolo completato', etc..)",
        },
        {
          date: "16 Agosto 2026",
          title: "Nuova visuale: 'Panoramica'",
          description:
            "Nuova visuale 'Panoramica': tutte le rose, svincolati, pianificazione e chat in un'unica schermata personalizzabile. La puoi attivare tramite l'apposita icona dell topbar.",
        },
        {
          date: "16 Agosto 2026",
          title: "Pallini... spostabili",
          description:
            "Come ci avete richiesto, quando rimpicciolisci un popup, il pallino può essere trascinato dove preferisci.",
        },
        {
          date: "16 Agosto 2026",
          title: "'Tutte le rose' da mobile",
          description:
            "Nuovo pulsante su mobile per vedere tutte le rose della lega in maniera compatta.",
        },
        {
          date: "11 Agosto 2026",
          title: "Gestione amministratore d'asta",
          hideOnStandalone: true,
          description:
            "Possibilitá di scegliere chi ha il permesso di impostare o cambiare l'amministratore d'asta.",
        },
         {
          date: "9 Agosto 2026",
          title: "Asta-live.com",
          hideOnStandalone: true,
          description:
            "Asta Live disponibile su <a href='https://asta-live.com' target='_blank'>asta-live.com</a> come tool standalone anche per chi non gioca su Fantapazz.com. PS: Nella versione standalone ci sono anche i ruoli Mantra!",
        },
        {
          date: "8 Agosto 2026",
          title: "Max calciatori dello stesso club potenziata",
          hideOnStandalone: true,
          description:
            "La regola può essere configurata per singolo ruolo oppure come limite totale per rosa, con la possibilità di escludere alcuni ruoli dal conteggio.",
        },
        {
          date: "31 Luglio 2026",
          title: "Cuoricini",
          description:
            "Ogni utente può assegnare da 0 a 5 cuori ai calciatori svincolati (e ordinare la lista in base a tali cuoricini)",
        },
        {
          date: "12 Giugno 2026",
          title: "Ordinamento svincolati",
          description:
            "La lista svincolati può essere ordinata per quotazione, nome, club e statistiche del calciatore.",
        },
        {
          date: "6 Giugno 2026",
          hideOnStandalone: true,
          title: "Gestione mercati dall'app",
          descriptionKey: "gestioneMercati",
        },
        {
          date: "5 Giugno 2026",
          title: "Menu laterale e topbar rinnovati",
          description:
            "Accesso più rapido a profilo, lega, preferenze, salvataggio assegnazioni e strumenti principali.",
        },
        {
          date: "3 Giugno 2026",
          title: "Modalità Assegna rinnovata",
          description:
            "In modalità Assegna non serve piú avviare/stoopare asta. Basta cliccare sugli svincolati per assegnarli direttamente.",
        },
        {
          date: "2 Giugno 2026",
          title: "Eliminato tasto Pausa",
          description:
            "Adesso ci sono solo due pulsanti: Avvia / Stoppa asta",
        }
      ],
    };
  },
  computed: {
    visibleEvents() {
      return this.events
        .filter((event) => {
          return (
            (!Config.STANDALONE || !event.hideOnStandalone) &&
            (Config.STANDALONE || !event.onlyOnStandalone)
          );
        })
        .map((event) => {
          if (event.descriptionKey == "gestioneMercati") {
            return {
              ...event,
              description:
                "L'" + this.adminLegaDivisioneLabel +
                " può controllare e modificare gli stati dei mercati direttamente da Asta Live.",
            };
          }

          return event;
        });
    },
  },
  mounted() {
    db.on("showChangeLog", this.show);
  },
  destroyed() {
    db.off("showChangeLog", this.show);
  },
  methods: {
    show() {
      this.dialog = true;
    },
    dismiss() {
      this.dialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-change-log-card {
  background: var(--v-navy-darken2);
  color: var(--v-text-base);
}

.change-log-timeline {
  padding-top: 4px;
}

.change-log-timeline::v-deep .v-timeline-item {
  padding-bottom: 14px;
}

.change-log-timeline::v-deep .v-timeline-item__divider {
  min-width: 45px;
}

.change-log-timeline::v-deep .v-timeline-item__dot {
  background: transparent !important;
  box-shadow: none !important;
  height: 8px;
  left: 5px;
  width: 8px;
}

.change-log-timeline::v-deep .v-timeline-item__inner-dot {
  height: 8px;
  margin: 0;
  width: 8px;
}

.change-log-timeline::v-deep::before {
  opacity: 0.35;
}

.change-log-timeline::v-deep .v-timeline-item__body {
  max-width: calc(100% - 18px);
}

.change-log-date {
  color: var(--v-navy-lighten3);
  font-size: 11px;
  font-weight: 700;
  line-height: 1.2;
  text-transform: uppercase;
}

.change-log-title {
  color: white;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.25;
  margin-top: 2px;
}

.change-log-description {
  color: var(--v-navy-lighten5);
  font-size: 12px;
  line-height: 1.35;
  margin-top: 3px;
}

.change-log-description::v-deep a {
  color: var(--v-secondary-base);
  font-weight: 700;
}

@media (max-width: 600px) {
  .change-log-content {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
}
</style>

<style lang="scss">
.v-application--is-ltr
  .dialog-change-log-card
  .v-timeline--dense:not(.v-timeline--reverse)::before,
.v-application--is-rtl
  .dialog-change-log-card
  .v-timeline--reverse.v-timeline--dense::before {
  background: var(--v-secondary-base) !important;
  left: 21px !important;
  right: auto !important;
}
</style>
